export default __webpack_public_path__ + "static/media/smiling-eyes.b44cfafd.png";